import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["translations"];
import { Team, TestIdProvider } from '@ori/testid-generator';
import { ErrorBoundary } from "./ErrorBoundary";
import { InnerProductBox } from "./InnerProductBox";
import { ProductProvider, TranslationsProvider } from "../context";
import { jsx as _jsx } from "react/jsx-runtime";
export var ProductBox = function ProductBox(_ref) {
  var translations = _ref.translations,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(TestIdProvider, {
      team: Team.Presentation,
      project: "product-box",
      children: /*#__PURE__*/_jsx(TranslationsProvider, {
        translations: translations,
        children: /*#__PURE__*/_jsx(ProductProvider, {
          value: props,
          children: /*#__PURE__*/_jsx(InnerProductBox, {})
        })
      })
    })
  });
};
//# sourceMappingURL=ProductBox.js.map